import app from '../main';

import { useUserStore } from '@/stores/user';

export default [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        meta: {
            header: 'Dashboard',
        },
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('../views/About.vue'),
    },
    {
        path: '/test',
        name: 'Test',
        component: () => import('../views/TestView.vue'),
    },
    {
        path: '/test2',
        name: 'Test2',
        component: () => import('../views/TestView2.vue'),
    },
    {
        path: '/test3',
        name: 'Test3',
        component: () => import('../views/TestView3.vue'),
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('../views/RegistrationFacade.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import('../views/ForgotPassword.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/reset-password/:token',
        name: 'ResetPassword',
        component: () => import('../views/ResetPassword.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/finalize-account/:token',
        name: 'FinalizeAccount',
        component: () => import('../views/ResetPassword.vue'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/team',
        name: 'Team',
        component: () => import('../views/Team.vue'),
        meta: {
            header: 'Team',
        },
    },
    {
        path: '/team/:hash',
        name: 'Employee Detail',
        component: () => import('../views/EmployeeDetail.vue'),
        meta: {
            header: 'Employee Profile',
        },
    },
    {
        path: '/inspections',
        name: 'Inspections',
        component: () => import('../views/Inspections.vue'),
        meta: {
            header: 'Inspections',
        },
    },
    {
        path: '/outbreak',
        name: 'Outbreak',
        component: () => import('../views/Outbreak.vue'),
        meta: {
            header: 'Outbreak',
        },
    },
    {
        path: '/audits/:hash?',
        name: 'Audits',
        component: () => import('../views/Audits.vue'),
        meta: {
            header: 'Auditing Suite',
        },
    },
    {
        path: '/library/:hash?',
        name: 'Library',
        component: () => import('../views/Library.vue'),
        meta: {
            header: 'Knowledge Library',
        },
    },
    {
        path: '/program',
        name: 'Program',
        component: () => import('../views/Program.vue'),
        beforeEnter: (to, from, next) => {
            const userStore = useUserStore();
            userStore.sync(() => {
                if (!userStore?.companyHasPerm('alpha:access')) {
                    //if user don't have alpha access - redirect to home;
                    // TODO: forward to dont have access page
                    next('/');
                } else {
                    next();
                }
            });
        },
        meta: {
            header: 'Program',
        },
    },
    {
        path: '/program/:hash',
        name: 'Program Overview',
        component: () => import('../views/ProgramOverview.vue'),
        beforeEnter: (to, from, next) => {
            const userStore = useUserStore();
            userStore.sync(() => {
                if (!userStore?.companyHasPerm('alpha:access')) {
                    //if user don't have alpha access - redirect to home;
                    // TODO: forward to dont have access page
                    next('/');
                } else {
                    next();
                }
            });
        },
        meta: {
            header: 'Program Overview',
        },
    },
    {
        path: '/secondment',
        name: 'Secondment',
        component: () => import('../views/Secondments.vue'),
        beforeEnter: (to, from, next) => {
            const userStore = useUserStore();
            userStore.sync(() => {
                if (!userStore?.hasPermOneOf('secondments:read')) {
                    next('/');
                } else {
                    next();
                }
            });
        },
        meta: {
            header: 'Secondment',
        },
    },
    {
        path: '/inventory/:hash?',
        name: 'Inventory',
        component: () => import('../views/Inventory.vue'),
        beforeEnter: (to, from, next) => {
            const userStore = useUserStore();
            userStore.sync(() => {
                if (!userStore?.hasPermOneOf('inventory:read')) {
                    //if user is not a company admin - redirect to home;
                    // TODO: forward to dont have access page
                    next('/');
                } else {
                    next();
                }
            });
        },
        meta: {
            header: 'Inventory Management',
        },
    },
    {
        path: '/courses',
        name: 'Courses',
        component: () => import('../views/Courses.vue'),
        beforeEnter: (to, from, next) => {
            const userStore = useUserStore();
            userStore.sync(() => {
                if (!userStore?.hasPermOneOf('courses:read')) {
                    //if user is not a company admin - redirect to home;
                    // TODO: forward to dont have access page
                    next('/');
                } else {
                    next();
                }
            });
        },
        meta: {
            header: 'Education Tracking',
        },
    },
    {
        path: '/settings',
        name: 'Settings',
        component: () => import('../views/Settings.vue'),
        meta: {
            header: 'Settings',
        },
    },
    {
        path: '/contact-us',
        name: 'Contact Us',
        component: () => import('../views/ContactUs.vue'),
        meta: {
            header: 'Contact Us',
        },
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('../views/Help.vue'),
        meta: {
            header: 'Help',
        },
    },
    {
        path: '/release-notes',
        name: 'ReleaseNotes',
        component: () => import('../views/ReleaseNotes.vue'),
        meta: {
            header: 'Release Notes',
        },
    },
    {
        path: '/admin',
        name: 'Admin',
        meta: {
            header: 'Admin Panel',
        },
        beforeEnter: (to, from, next) => {
            const userStore = useUserStore();
            userStore.sync(() => {
                if (!userStore.isAppAdmin) {
                    next('/');
                } else {
                    next();
                }
            });
        },
        children: [
            {
                path: '',
                component: () => import('../views/Admin.vue'),
                name: 'AdminPanel',
            },
            {
                path: 'company/:hash',
                name: 'Company Detail',
                component: () => import('../views/admin/general/Company.vue'),
            },
        ],
    },
    {
        path: '/pdf-viewer/:hash',
        name: 'PdfViewer',
        component: () => import('../views/PdfViewer.vue'),
    },

    // Keep this route as the last one
    {
        path: '/:pathMatch(.*)*',
        name: 'PageNotFound',
        component: () => import('../views/PageNotFound.vue'),
        meta: {
            requiresAuth: false,
        },
    },
];
